import { backButton as telegramBackButton } from '@tma.js/sdk';
import { isMockedEnvironment } from './telegram';

type BackButtonClickHandler = () => void;

interface MockBackButtonState {
    visible: boolean;
    onClickHandler: BackButtonClickHandler | null;
}

let mockState: MockBackButtonState = {
    visible: false,
    onClickHandler: null,
};

const observers = new Set<() => void>();

function notifyObservers() {
    observers.forEach(observer => observer());
}

export function subscribeToMockState(callback: () => void) {
    observers.add(callback);
    return () => {
        observers.delete(callback);
    };
}

export function getMockState() {
    return mockState;
}

const backButtonWrapper = {
    show() {
        if (isMockedEnvironment()) {
            mockState = { ...mockState, visible: true };
            notifyObservers();
        } else {
            telegramBackButton.show();
        }
    },

    hide() {
        if (isMockedEnvironment()) {
            mockState = { ...mockState, visible: false };
            notifyObservers();
        } else {
            telegramBackButton.hide();
        }
    },

    onClick(handler: BackButtonClickHandler) {
        if (isMockedEnvironment()) {
            mockState = {
                visible: mockState.visible,
                onClickHandler: handler,
            };
            notifyObservers();
            return () => {
                mockState = { ...mockState, onClickHandler: null };
                notifyObservers();
            };
        } else {
            return telegramBackButton.onClick(handler);
        }
    },

    mount() {
        if (!isMockedEnvironment()) {
            telegramBackButton.mount();
        }
    },

    isSupported() {
        if (isMockedEnvironment()) {
            return true;
        }
        return telegramBackButton.isSupported();
    },
};

export const backButton = backButtonWrapper;
